// AUTH ACTION TYPES

//LOGIN
export const LOGIN_INIT = "LOGIN_INIT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

//FORGOT PASSWORD
export const FORGOT_PASSWORD_INIT = 'FORGOT_PASSWORD_INIT';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';

//RESET PASSWORD
export const RESET_PASSWORD_INIT = 'RESET_PASSWORD_INIT';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';


// AUTH LOGOUT
export const LOGOUT_INIT = "LOGOUT_INIT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

//SIGNUP
export const SIGNUP_INIT = "SIGNUP_INIT";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";

//CREATE_EVENT
export const CREATE_EVENT_INIT = "CREATE_EVENT_INIT";
export const CREATE_EVENT_SUCCESS = "CREATE_EVENT_SUCCESS";
export const CREATE_EVENT_FAIL = "CREATE_EVENT_FAIL";

//VIEWE_EVENT
export const VIEW_EVENT_INIT = "VIEW_EVENT_INIT";
export const VIEW_EVENT_SUCCESS = "VIEW_EVENT_SUCCESS";
export const VIEW_EVENT_FAIL = "VIEW_EVENT_FAIL";

//DELETE_EVENT
export const DELETE_EVENT_INIT = "DELETE_EVENT_INIT";
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_FAIL = "DELETE_EVENT_FAIL";

//UPDATE_EVENT
export const UPDATE_EVENT_INIT = "UPDATE_EVENT_INIT";
export const UPDATE_EVENT_SUCCESS = "UPDATE_EVENT_SUCCESS";
export const UPDATE_EVENT_FAIL = "UPDATE_EVENT_FAIL";

//GET_CATEGORY
export const GET_CATEGORY_INIT = "GET_CATEGORY_INIT";
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_FAIL = "GET_CATEGORY_FAIL";

// VIEW EVENT PHOTOS
export const GET_EVENT_MEDIA_INIT = "GET_EVENT_MEDIA_INIT";
export const GET_EVENT_MEDIA_SUCCESS = "GET_EVENT_MEDIA_SUCCESS";
export const GET_EVENT_MEDIA_FAIL = "GET_EVENT_MEDIA_FAIL";

// UPLOAD_MEDIA
export const UPLOAD_EVENT_MEDIA_INIT = "UPLOAD_EVENT_MEDIA_INIT";
export const UPLOAD_EVENT_MEDIA_SUCCESS = "UPLOAD_EVENT_MEDIA_SUCCESS";
export const UPLOAD_EVENT_MEDIA_FAIL = "UPLOAD_EVENT_MEDIA_FAIL";

// DELETE_MEDIA
export const DELETE_EVENT_MEDIA_INIT = 'DELETE_EVENT_MEDIA_INIT';
export const DELETE_EVENT_MEDIA_SUCCESS = 'DELETE_EVENT_MEDIA_SUCCESS';
export const DELETE_EVENT_MEDIA_FAIL = 'DELETE_EVENT_MEDIA_FAIL';


//ADD_GUEST
export const ADD_GUEST_INIT = "ADD_GUEST_INIT";
export const ADD_GUEST_SUCCESS = "ADD_GUEST_SUCCESS";
export const ADD_GUEST_FAIL = "ADD_GUEST_FAIL";

//VIEW_GUEST
export const VIEW_GUEST_INIT = "VIEW_GUEST_INIT";
export const VIEW_GUEST_SUCCESS = "VIEW_GUEST_SUCCESS";
export const VIEW_GUEST_FAIL = "VIEW_GUEST_FAIL";

//DELETE_GUEST
export const DELETE_GUEST_INIT = "DELETE_GUEST_INIT";
export const DELETE_GUEST_SUCCESS = "DELETE_GUEST_SUCCESS";
export const DELETE_GUEST_FAIL = "DELETE_GUEST_FAIL";

//UPDATE_GUEST
export const UPDATE_GUEST_INIT = "UPDATE_GUEST_INIT";
export const UPDATE_GUEST_SUCCESS = "UPDATE_GUEST_SUCCESS";
export const UPDATE_GUEST_FAIL = "UPDATE_GUEST_FAIL";

//CONTACT_US
export const CONTACT_US_INIT = "CONTACT_US_INIT";
export const CONTACT_US_SUCCESS = "CONTACT_US_SUCCESS";
export const CONTACT_US_FAIL = "CONTACT_US_FAIL";

//GET EMAIL-CONGIF
export const GET_EMAIL_CONGIF_INIT = "CONTGET_EMAIL_CONGIF_INITACT_US_INIT";
export const GET_EMAIL_CONGIF_SUCCESS = "GET_EMAIL_CONGIF_SUCCESS";
export const GET_EMAIL_CONGIF_FAIL = "GET_EMAIL_CONGIF_FAIL";

//CREATE EMAIL-DATA
export const CREATE_EMAIL_INIT = "CREATE_EMAIL_INIT";
export const CREATE_EMAIL_SUCCESS = "CREATE_EMAIL_SUCCESS";
export const CREATE_EMAIL_FAIL = "CREATE_EMAIL_FAIL";

//SENND REQ-REVIEW
export const SEND_REQ_REVIEW_INIT = "SEND_REQ_REVIEW_INIT";
export const SEND_REQ_REVIEW_SUCCESS = "SEND_REQ_REVIEW_SUCCESS";
export const SEND_REQ_REVIEW_FAIL = "SEND_REQ_REVIEW_FAIL";

//GET ALL TESTIMONIALS
export const FETCH_TESTIMONIALS_INIT = "FETCH_TESTIMONIALS_INIT";
export const FETCH_TESTIMONIALS_SUCCESS = "FETCH_TESTIMONIALS_SUCCESS";
export const FETCH_TESTIMONIALS_FAIL = "FETCH_TESTIMONIALS_FAIL";

//DELETE TESTIMONIALS
export const DELETE_TESTIMONIALS_INIT = "DELETE_TESTIMONIALS_INIT";
export const DELETE_TESTIMONIALS_SUCCESS = "DELETE_TESTIMONIALS_SUCCESS";
export const DELETE_TESTIMONIALS_FAIL = "DELETE_TESTIMONIALS_FAIL";

//GET USER PROFILE
export const GET_PROFILE_INIT = "GET_PROFILE_INIT";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL";

//UPDATE PROFILE
export const UPDATE_PROFILE_INIT = "UPDATE_PROFILE_INIT";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

//GET PAYMENT PLANS
export const GET_PAYMENT_INIT = "GET_PAYMENT_INIT";
export const GET_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
export const GET_PAYMENT_FAIL = "GET_PAYMENT_FAIL";

